bq.toggleItems = function(element) {
  this.$element  = $(element);
  this.lines = $('.collapse', element);
  this.collapseButton = $('.collapse-all', element);
  this.expandButton = $('.expand-all', element);
  this.buttonsContainer = $('.line-items-toggle', element);
  this.linesVisibility = {};
  this.mainVisibility = null;
};

bq.toggleItems.prototype = {

  init: function() {
    var $this = this;

    $this.fillLinesStatuses();

    $this.collapseButton.on('click', {thiz: $this}, $this.collapseLines);
    $this.expandButton.on('click', {thiz: $this}, $this.expandLines);

    $('.view-more-details', $this.$element).each(function() {
      $('.more, .less', this).on('click', {parentContainer: this}, $this.toggleDetails);
    });

    $('.toggle-item-link', $this.$element).each(function() {
      $(this).on('click', {target: $(this).data('toggle-target'), thiz: $this}, $this.toggleOneLine)
    });
  },

  toggleOneLine: function(e) {
    var target = e.data.target;
    var $this = e.data.thiz;

    $(target).toggle();

    $this.fillLinesStatuses();
  },

  toggleDetails: function(e) {
    var parentContainer = e.data.parentContainer;

    $(parentContainer).prev('.item-options-container').toggleClass('hidden');
    $('a', parentContainer).toggleClass('hidden');
  },

  collapseLines: function(e) {
    var $this = e.data.thiz;

    $this.lines.hide();

    $this.toggleArrowIcon('up', 'down');
  },

  expandLines: function(e) {
    var $this = e.data.thiz;

    $this.lines.show();

    $this.toggleArrowIcon('down', 'up');
  },

  toggleArrowIcon: function(from, to) {
    $('span[data-bq="collapse"]', this.$element).each(function(){
      if ($(this).hasClass('fa-angle-double-' + from)) {
        $(this).removeClass('fa-angle-double-' + from).addClass('fa-angle-double-' + to);
      }
    });

    $('a', this.buttonsContainer).toggleClass('hidden');
    this.fillLinesStatuses();
  },

  fillLinesStatuses: function() {
    var $this = this;

    $this.lines.each(function() {
      $this.linesVisibility[$(this).attr('id')] = $(this).is(':visible') ? 'visible' : 'invisible';
    });

    $this.checkAllItemsTheSame();
  },

  checkAllItemsTheSame: function() {
    var $this = this;

    var allLinesTheSame = Object.keys($this.linesVisibility).every(function(line) {
      return $this.linesVisibility[line] === $this.linesVisibility[Object.keys($this.linesVisibility)[0]];
    });

    if (allLinesTheSame) {
      $this.mainVisibility = $this.linesVisibility[Object.keys($this.linesVisibility)[0]];

      $this.showProperButton();
    }
  },

  showProperButton: function() {
    var properButton = this.mainVisibility === 'visible' ? this.collapseButton : this.expandButton;

    if (properButton.is(':visible')) return;

    $('a', this.buttonsContainer).toggleClass('hidden');
  }
};

var toggleItemsold = $.fn.toggleItems;

$.fn.toggleItems = function () {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.toggleItems');
    var options = $.extend({}, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.toggleItems', (data = new bq.toggleItems(this, options))); }
    data.init();
  });
};

$.fn.toggleItems.Constructor = bq.toggleItems;

$.fn.toggleItems.noConflict = function () {
  $.fn.toggleItems = toggleItemsold;
  return this;
};

bq.global.toggleLinesInit = function() {
  $('.grid-collapsable-items').each(function() {
    var el = $(this);
    if(el.data('bq.toggleItems')) { return; }
    el.toggleItems(el.data());
  });
};

bq.init.push(bq.global.toggleLinesInit);